
import React from 'react';
import './MetricCard.css';
import { Tag } from '../Tag/Tag';

type MetricCardProps = {
  title: string;
  score: number;
  description: string;
  highlight?: string;
};

export const MetricCard: React.FC<MetricCardProps> = ({
  title,
  score,
  description,
  highlight,
}) => {
  const tone = score >= 85 ? 'good' : score >= 70 ? 'warn' : 'bad';
  const label =
    tone === 'good' ? '达标' : tone === 'warn' ? '轻微偏离' : '明显风险';

  return (
    <div className="metric-card">
      <div className="metric-card-header">
        <div className="metric-card-title">{title}</div>
        <Tag type={tone}>{label}</Tag>
      </div>
      <div className="metric-card-score">{score}</div>
      <div className="metric-card-desc">{description}</div>
      {highlight && <div className="metric-card-highlight">{highlight}</div>}
      <div className="metric-card-bar">
        <div
          className={`metric-card-bar-fill metric-${tone}`}
          style={{ width: `${Math.max(10, score)}%` }}
        />
      </div>
    </div>
  );
};
